import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { ProductTable } from '../../components/common/ProductTable';
import { PATHS } from '../../configs/path';
import { productEditingModes } from '../../constants/productApproval';
import {
  getFormattedStatusFirstCapital,
  isObjectEmptyOrNull,
} from '../../helpers/utils';
import { useProductTable } from '../../hooks/useProductTable';
import { ListingModalContent } from './ListingModalContent';
import { useLayoutContext } from '../../context/LayoutContext';
// import { ApprovalModalContent } from "./ApprovalModalContent";
import './listing.scss';
import { Status } from '../../constants/status';
import { ListingDetailsModalContent } from './ListingDetailsModalContent';
import { PageTitleHeader } from '../../components/common/PageTitleHeader';
import { LoadingContainer } from '../../components/common/LoadingContainer';
import StatusPill from '../../components/common/status-pill/StatusPill';
import productAPI from '../../services/API/product';
import { useUserContext } from '../../context/UserContext';
import { MenuItem, Select, TextField } from '@material-ui/core';
import downIcon from '../../assets/images/down.svg';
import upIcon from '../../assets/images/up.svg';
import searchIcon from '../../assets/images/searchIcon.svg';
import { FeatureNotAvailable } from '../../components/common/feature-not-available/FeatureNotAvailable';
import { makeStyles } from '@mui/styles';
import { MEMBER_SUBSCRIPTION_STATUS } from '../../constants/appConst';

const useStyles = makeStyles({
  searchBar: {
    position: 'relative',
    width: '100%',
    borderRadius: '30px',
    border: '1px solid #2E2B2B',
    height: 51,
    display: 'flex',
    alignItems: 'center',
    padding: '0px 15px',
    marginTop: '10px',
  },
  searchInput: {
    width: '100%',
    border: 'none',
    fontFamily: 'Brown',
    backgroundColor: 'transparent',
    '&:focus-visible': {
      outline: 'none',
    },
  },
});

export const MyListing = () => {
  // Routing related
  const history = useHistory();
  const match = useRouteMatch();
  const { user } = useUserContext();
  const { showNavBar } = useLayoutContext();
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  const classes = useStyles();

  const {
    detailOpen,
    setDetailOpen,
    loadingProducts,
    products,
    setProducts,
    setSelectedProductIndex,
    selectedProduct,
    refreshProducts,

    detailPageButtonStates,

    updateProductStatus,
    updateProductDetails,
    addProduct,
    deleteProduct,

    loadProductStatuses,
    productStatusList,
  } = useProductTable({
    status: selectedStatus || 'consignments',
    userID: 340,
  });

  const [isAddNew, setIsAddNew] = useState(false);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [isFiltering, setIsFiltering] = React.useState(false);
  const [selectedStatusList, setSelectedStatusList] = React.useState([]);
  const [filteredProduct, setFilteredProducts] = React.useState([]);
  const [searchedProducts, setSearchedProducts] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');

  const ITEM_HEIGHT = 80;
  const ITEM_PADDING_TOP = 20;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        overflowY: 'scroll',
        width: 260,
        backgroundColor: '#fef1e7',
        borderRadius: 30,
        border: '1px solid #2E2B2B',
        boxShadow: 'none',
      },
    },
  };

  const isSM = windowWidth <= 900;
  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  useEffect(() => {
    // hides the product details page when back button is pressed
    if (!isAddNew) {
      if (match.params && detailOpen && match.params.id === undefined) {
        setDetailOpen(false);
        localStorage.setItem('modalOpen', JSON.stringify(false));
      }
    }
  }, [match.params]);

  useEffect(() => {
    const getSearchData = async () => {
      if (searchText !== '') {
        setIsFiltering(true);
        const reqData = {
          search_field: 'title',
          search_term: searchText?.trim(),
        };
        const res = await productAPI.getSearchProduct(reqData);
        const newData =
          selectedStatus === null || selectedStatus === 'consignments'
            ? res?.filter(
                (data) => data.consigned_by_user_id === (user?.id).toString()
              )
            : res?.filter(
                (data) =>
                  data.consigned_by_user_id === (user?.id).toString() &&
                  data.status ===
                    (selectedStatus ? selectedStatus : 'consignments')
              );
        setSearchedProducts(newData);
        setIsFiltering(false);
      } else {
        setSearchedProducts([]);
        setIsFiltering(false);
      }
    };
    getSearchData();
  }, [searchText]);

  const handleOpenAddNewModal = () => {
    setDetailOpen(true);
    setSelectedProductIndex(-1);
    setIsAddNew(true);
    localStorage.setItem('modalOpen', JSON.stringify(true));
  };

  // handles selecting and openinng product details
  const onProductSelected = useCallback((index, id) => {
    setIsAddNew(false);
    history.push(`${PATHS.listings}/${id}`); // productsRef.current[index].id);
    setSelectedProductIndex(index);
    localStorage.setItem('modalOpen', JSON.stringify(true));
    setDetailOpen(true);
  }, []);

  // handle close product details
  const onCloseDetailsModal = () => {
    if (match.params.id !== undefined) {
      history.push(PATHS.listings);
    }
    setSelectedProductIndex(-1);
    localStorage.setItem('modalOpen', JSON.stringify(false));
    setDetailOpen(false);
  };

  const handleUpdateProductStatus = (buttonIndex, newUpdate) => {
    updateProductStatus(newUpdate, buttonIndex, (response) => {
      if (response.data === 'listed') {
        setProducts((oldProducts) => {
          let newProducts = oldProducts.filter((np) => np.status !== 'listed');
          return newProducts;
        });
        onCloseDetailsModal();
      }
    });
  };

  const handleDeleteProduct = (buttonIndex, newUpdate) => {
    deleteProduct(newUpdate, buttonIndex);
  };

  const isThereSelectedProduct = !isObjectEmptyOrNull(selectedProduct);
  const editingMode = isThereSelectedProduct
    ? productEditingModes.EXTENDED_EDIT_EXISTING
    : productEditingModes.ADD_NEW;

  const handleSubmit = async (values) => {
    if (values?.length > 0) {
      if (values && typeof values !== 'string' && user.id) {
        const value = values[values.length - 1];
        setIsFiltering(true);
        const alreadyExists = selectedStatusList.find((s) => s.value === value);
        if (!alreadyExists) {
          const s = productStatusList.find((s) => s.status === value);
          if (s) {
            setSelectedStatusList(
              selectedStatusList.concat({
                value,
                title: s.status_display_user,
              })
            );
          }
          const res = await productAPI.getProductsByStatus({
            status: value,
            user_id: user.id,
          });
          setFilteredProducts(filteredProduct.concat(res));
          setProducts(filteredProduct.concat(res));
          setIsFiltering(false);
        }
      } else {
        if (values && user.id) {
          setIsFiltering(true);
          const res = await productAPI.getProductsByStatus({
            status: values,
            user_id: user.id,
          });
          setFilteredProducts(res);
          setProducts(res);
          setIsFiltering(false);
        }
      }
    } else {
      setSelectedStatusList([]);
    }
  };

  return (
    <Row style={!showNavBar ? { justifyContent: 'center' } : {}}>
      {loadProductStatuses ? (
        <LoadingContainer />
      ) : user.member_status !== MEMBER_SUBSCRIPTION_STATUS.CANCELLED ? (
        <Col sm='12' md='12' lg='12' xl='10' className='mx-autos'>
          <Row style={{ marginBottom: 25 }}>
            <PageTitleHeader
              className={'mb-0'}
              title={
                detailOpen
                  ? isAddNew
                    ? 'Add a new listing'
                    : `Listing #${selectedProduct.id}`
                  : 'Listings'
              }
            />
            <div
              className={`label mb-3 w-100 text-center pt-3 ${
                !detailOpen && user.member_status === MEMBER_SUBSCRIPTION_STATUS.PAUSED &&
                'd-none'
              }`}
            >
              <span
                className='link-text'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (detailOpen) {
                    setDetailOpen(false);
                    localStorage.setItem('modalOpen', JSON.stringify(false));
                    history.push(`${PATHS.listings}/`);
                    if (isAddNew) {
                      setIsAddNew(false);
                    }
                  } else {
                    handleOpenAddNewModal();
                  }
                }}
              >
                {detailOpen
                  ? 'Back to listings'
                  : user.member_status === MEMBER_SUBSCRIPTION_STATUS.ACTIVE
                  ? 'Add new listing'
                  : null}
              </span>
            </div>
          </Row>
          {detailOpen ? null : (
            <>
              <Row
                style={{
                  alignItems: 'center',
                  paddingLeft: '1.75rem',
                  paddingRight: '1.75rem',
                }}
              >
                <Col xs='12' sm='6' md='7' lg='7' xl='8' className='mx-autos'>
                  <div className={classes.searchBar}>
                    <img
                      src={searchIcon}
                      alt='search product'
                      style={{ height: 16, width: 16, marginRight: '5px' }}
                    />
                    <input
                      name='search'
                      placeholder='Search'
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      className={classes.searchInput}
                    />
                  </div>
                </Col>
                <Col xs='12' sm='6' md='5' lg='5' xl='4' className='mx-autos'>
                  <Select
                    value={selectedStatus || ''}
                    name='productStatus'
                    id='productStatus'
                    displayEmpty
                    disableUnderline
                    MenuProps={MenuProps}
                    IconComponent={() => {
                      return (
                        <img
                          src={downIcon}
                          style={{ height: 14, width: 14 }}
                          alt={'down'}
                        />
                      );
                    }}
                    onChange={(e) => {
                      setSelectedStatus(e.target.value);
                      setSearchText('');
                      // handleSubmit(e.target.value);
                    }}
                    className={
                      'd-flex align-items-center justify-content-center mr-3 px-3 select-dropdown'
                    }
                    style={{ borderRadius: 30, height: 51, marginTop: 10 }}
                    inputProps={{ 'aria-label': 'Without label' }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span>Filter by status</span>;
                      }
                      const selectedStatusData = productStatusList.find(
                        (p) => p.status === selected
                      );
                      if (
                        selectedStatusData &&
                        selectedStatusData.status_display_user
                      ) {
                        return getFormattedStatusFirstCapital(
                          selectedStatusData.status_display_user
                        );
                      } else {
                        return selected[selected];
                      }
                    }}
                  >
                    {/* <MenuItem
                      value={''}
                      disabled
                      style={{
                        paddingTop: 8,
                        paddingBottom: 8,
                        fontSize: 16,
                        fontFamily: 'Brown',
                        borderBottom: `1px solid #2E2B2B`,
                        justifyContent: 'space-between',
                        backgroundColor: 'transparent',
                      }}
                    >
                      <span style={{ fontSize: 16, fontFamily: 'Brown' }}>
                        Filter by status
                      </span>
                      <img
                        src={upIcon}
                        style={{ height: 13, width: 12 }}
                        alt={'up'}
                      />
                    </MenuItem> */}
                    {productStatusList.map((opt, index) => {
                      return (
                        <MenuItem
                          value={opt.status}
                          style={{
                            paddingTop: 10,
                            paddingBottom: 10,
                            fontSize: 16,
                            fontFamily: 'Brown',
                            backgroundColor:
                              selectedStatus === opt.status
                                ? '#F9E4D7'
                                : 'transparent',
                          }}
                          disableRipple
                          disableTouchRipple
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = '#F9E4D7')
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = 'transparent')
                          }
                        >
                          {getFormattedStatusFirstCapital(
                            opt.status_display_user
                          )}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
            </>
          )}

          {/* <img src={lendImage} style={{ height: 100, width: 100 }} /> */}
          {detailOpen ? (
            editingMode !== productEditingModes.ADD_NEW &&
            selectedProduct.status !== Status.draft_by_lender ? (
              <ListingDetailsModalContent
                productData={selectedProduct}
                updateProductDetails={updateProductDetails}
                updateProductStatus={handleUpdateProductStatus}
                deleteProduct={handleDeleteProduct}
                detailPageButtonStates={detailPageButtonStates}
                editingMode={editingMode}
                handleAddNewProduct={addProduct}
                isSM={isSM}
                onCloseModal={() => {
                  setDetailOpen(false);
                  localStorage.setItem('modalOpen', JSON.stringify(false));
                  history.push(`${PATHS.listings}/`);
                }}
              />
            ) : (
              <ListingModalContent
                productData={selectedProduct}
                updateProductDetails={updateProductDetails}
                updateProductStatus={handleUpdateProductStatus}
                deleteProduct={handleDeleteProduct}
                detailPageButtonStates={detailPageButtonStates}
                editingMode={editingMode}
                handleAddNewProduct={addProduct}
                isSM={isSM}
                onCloseModal={() => {
                  setDetailOpen(false);
                  setIsAddNew(false);
                  localStorage.setItem('modalOpen', JSON.stringify(false));
                }}
              />
            )
          ) : (
            <ProductTable
              title='My Listings'
              loadingProducts={loadingProducts || isFiltering}
              // products={products}
              products={searchText !== '' ? searchedProducts : products}
              handleOpenDetail={onProductSelected}
              allowRefresh
              handleRefresh={refreshProducts}
            />
          )}
        </Col>
      ) : (
        <FeatureNotAvailable />
      )}

      {/* <DetailsModalScaffold
        isOpen={detailOpen}
        toggle={() => {
          setDetailOpen(false);
          localStorage.setItem('modalOpen', JSON.stringify(false));
        }}
        handleClose={onCloseDetailsModal}
        className='product-details-modal'
      >
        {detailOpen &&
          (editingMode !== productEditingModes.ADD_NEW &&
          selectedProduct.status !== Status.draft_by_lender ? (
            <ListingDetailsModalContent
              productData={selectedProduct}
              updateProductDetails={updateProductDetails}
              updateProductStatus={handleUpdateProductStatus}
              deleteProduct={handleDeleteProduct}
              detailPageButtonStates={detailPageButtonStates}
              editingMode={editingMode}
              handleAddNewProduct={addProduct}
            />
          ) : (
            <ListingModalContent
              productData={selectedProduct}
              updateProductDetails={updateProductDetails}
              updateProductStatus={handleUpdateProductStatus}
              deleteProduct={handleDeleteProduct}
              detailPageButtonStates={detailPageButtonStates}
              editingMode={editingMode}
              handleAddNewProduct={addProduct}
            />
          ))}
      </DetailsModalScaffold> */}
    </Row>
  );
};
